import * as React from 'react'
import InputField from '../../common/components/input-field'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import QueryString from 'query-string'
import checkOptions from '../../common/options/check-options'
import { getQueryString } from '../../common/util'

import { withProductDataDefered } from '../../common/modules/product-data'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withState } from '../../common/modules/state'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields;

    return {
        
        rules: {
            "requester.firstName":[
                Validation.enforce.required("Please enter your first name."),
            ],
            "requester.surname":[
                Validation.enforce.required("Please enter your last name."),
            ],
            "requester.email":[
                Validation.enforce.required("Please type a valid email address"),
                Validation.enforce.email("Please type a valid email address.")
            ],
            "requester.phone":[
                Validation.enforce.required("Please type a valid phone number."),
            ],
        },

        predicates:{},
        options:{},
        inferred:{},
        
        transformOut: data => {
            const referenceCode = getQueryString().referenceCode ? getQueryString().referenceCode.trim() : "";
            return referenceCode
                ? { ...data, referenceCode }
                : data
        }

    }

}

@withSubmission
@withNavigation
@withValidation
@withRouteBlocker
@withProductDataDefered
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    render() {
        return (   
            <div className="row">
                <StepTitle>Let's get started</StepTitle>

                <StepBlock>
                    <p>Tell Us About Your Personal Information</p>
                </StepBlock>

                <InputField  field="requester.firstName" label="First name" />
                <InputField  field="requester.surname"   label="Last name" />
                
                <SubHeader>How can we contact you?</SubHeader>
                
                <InputField  field="requester.phone"     label="Phone"       description="Please include area code if you're providing a landline e.g. 0298765432" />
                <InputField  field="requester.email"     label="Email"       description="This will allow us to forward you the quote and to retrieve it in the future." />

                
                <StepBlock>
                    <p>By continuing with this quote you agree that the right <a href ='https://www.flexinsurance.com.au/residential-strata/#importantdocuments' target="_blank"><strong>PDS</strong></a> has been made available to you; you have read and agree with our <a href='https://flexinsurance.com.au/resource/privacy-policy/' target="_blank"><strong>Privacy Policy</strong></a>, <a href='https://flexinsurance.com.au/resource/legal-notices/'  target="_blank"><strong>Legal Notices</strong></a> & <a href='https://flexinsurance.com.au/resource/duty-of-disclosure/'  target="_blank"><strong>Duty of Disclosure</strong></a> and consent to receiving policy documents via electronic means. You also agree that Flex may share the information which you have provided to it with its related body corporate(s) CHU Underwriting Agencies Pty Ltd (ABN 19001 580 070, AFSL no 243261) not only for the purpose of this Flex product but also for the secondary purpose of products offered by that related body corporate and you consent to such disclosure.</p>
                </StepBlock>

                <Button.Container>
                    <Button.Continue onClick={ this.validate.bind(this) } />
                </Button.Container>
            </div>
        )
    }


    validate(){
        console.log("Validates")
        const fields = this.props.fields;
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.quoteSetup;
        this.props.actions.submission.submit(endpoint, this.requestProductData.bind(this), [
            require('./step-1').formConfig
        ] );
    }


    requestProductData(){
        this.props.actions.productData.requestProductData( this.proceed.bind(this) )
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-2")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-1.tsx